export const SET_ALL_LOADING_DATA = 'SET_ALL_LOADING_DATA';
export const SET_SHOW_LOADING = 'SET_SHOW_LOADING';
export const SET_BOOKING_LOADING = 'SET_BOOKING_LOADING';
export const SET_SEARCH_LOADING = 'SET_RESULT_LOADING';
export const SET_SEARCH_DATA = 'SET_RESULT_DATA';
